import React from "react";
import { Center } from "@chakra-ui/react";
import { LayoutProps } from "./types";

const CenterLayout: React.FC<LayoutProps> = ({ children }) => {
  return <Center height="full">{children}</Center>;
};

export default CenterLayout;
